<mat-card class="confirmation-card">
  <mat-card-header>
    <mat-card-title class="confirmation-title">
      <h2>
        Case <span class="case-id">{{ caseId }}</span> has been lodged with CIS.
      </h2>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="confirmation-message">
      <p class="p-justify">
        To make any changes or follow up on the accomodation please contact us
        on:
      </p>
      <p class="link">
        Slack: <span class="bold-text">temp_accom_bookings</span>
      </p>

      <p>
        Email:
        <a class="link" href="mailto:accom@cisassist.com.au">{{ email }}</a>
      </p>
      <p class="p-justify">
        Please note that our operating hours are weekdays from 7:00 AM to 5:00
        PM. We will review and action your request during these business hours.
        If your request is received outside of these times, please be assured
        that it will be addressed promptly once we are back in the office.
      </p>
    </div>
  </mat-card-content>
</mat-card>
<div class="btn">
  <button mat-raised-button color="primary" (click)="goBack()">
    ⬅️ Back to Main Page
  </button>
</div>
